import { FC, useMemo } from 'react';

import {
  CalendarIcon,
  ImportExportIcon,
  InboxIcon,
  ProfileIcon,
  SalesIcon,
} from 'ui/components/icon';
import { cn } from 'utils/helpers';

// const ICON_SOURCE = {
//   CONTACTS: ['LEADS', 'COMPANYS'],
//   SALES: ['TASKS', 'INVOICES', 'DEALS'],
//   CALENDAR: ['EVENTS', 'BOOKINGS'],
//   IMPORT_EXPORT: ['DATA'],
//   CHANNELS: ['SMS'],
// };

interface PROPS {
  source: string;
}

const NotificationIcon: FC<PROPS> = ({ source }) => {
  const icon = useMemo(() => {
    switch (source) {
      case 'CALENDAR':
        return <CalendarIcon className="h-3 w-3 text-fill-tertiary" />;
      case 'SALES':
        return <SalesIcon className="h-3 w-3 text-fill-tertiary" />;
      case 'IMPORT_EXPORT':
        return <ImportExportIcon className="h-3 w-3 text-fill-tertiary" />;
      case 'CHANNELS':
        return <InboxIcon className="h-3 w-3 text-fill-tertiary" />;
      default:
        return <ProfileIcon className="h-3 w-3 text-fill-tertiary" />;
    }
  }, [source]);

  return (
    <div
      className={cn(
        'rounded-full bg-content h-6 w-6',
        'flex items-center justify-center',
      )}
    >
      {icon}
    </div>
  );
};

export default NotificationIcon;
